import { NewAccountTrigger } from "../components/modals/NewAccountTrigger.tsx";
import AccountList from "../components/AccountList.tsx";
import type { User } from "firebase/auth";

interface AccountsProps {
  user: User | null;
}

const Accounts: React.FC<AccountsProps> = ({ user }) => {
  if (!user) {
    return <div>Please Login</div>;
  }

  return (
    <div className="w-min max-w-full py-4 mx-auto px-[5%]">
      <div className="mb-8">
        <div className="flex justify-between items-center mb-4 min-w-min">
          <h2 className="text-2xl font-semibold">Volo Database</h2>
          <NewAccountTrigger />
        </div>

        <div className="bg-white rounded-xs shadow">
          <AccountList />
        </div>
      </div>
    </div>
  );
};

export default Accounts;
